<template>
	<div class="block">
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span>已选&nbsp;</span>
				<span style="font-weight: 400; color: #999;">({{ this.keywordsList().length }}个)</span>
				<!-- <el-button style="float: right; padding: 3px 0" type="text">导出</el-button> -->
			</div>
			<div class="box-body">
				<div v-for="(item, index) in keywordsList()" :key="index" class="text item">
					<span>
						{{ item.keywords }}
					</span>
					<div class="tag" v-if="item.resource === '手动添加'">
						<el-tag size="mini">手动</el-tag>
					</div>
				</div>
			</div>
		</el-card>
	</div>
</template>
<script>
export default {
	props: {
		labelPosition: {
			type: String,
			default: 'right',
		},
		list: {
			type: Object,
		},
	},
	inject: ['keywordsList'],
	mounted() {},
};
</script>
<style scoped lang="scss">
.text {
  font-size: 14px;
  display: flex;
  align-items: center;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tag {
    margin-left: 5px;

    .el-tag {
      padding: 0 2px;
    }
  }
}

::v-deep  .el-card__body {
  padding: 0;
}

.item {
  margin-bottom: 10px;
}

.clearfix::before,
.clearfix::after {
  display: table;
  content: '';
}

.clearfix::after {
  clear: both;
}

.box-card {
  width: 480px;
}

.box-body {
  height: 150px;
  overflow-y: auto;
  padding: 10px 15px;
  // 改变滚动条样式
  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #e8e8e8;
    height: 50px;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
    border-radius: 2px;
  }
}
</style>
